import { render, staticRenderFns } from "./EditProBrand.modal.vue?vue&type=template&id=dcb138bc&scoped=true&"
import script from "./EditProBrand.modal.vue?vue&type=script&lang=js&"
export * from "./EditProBrand.modal.vue?vue&type=script&lang=js&"
import style0 from "./EditProBrand.modal.vue?vue&type=style&index=0&id=dcb138bc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcb138bc",
  null
  
)

export default component.exports